import { useState, useEffect } from "react";
import { ArrowUp, MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";

export default function FloatingButtons() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed right-4 md:right-6 flex flex-col items-center gap-3"
      style={{ bottom: "max(1rem, env(safe-area-inset-bottom, 0px))", zIndex: 90 }}
      data-testid="floating-buttons"
    >
      {/* Scroll to Top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        data-testid="floating-scroll-top"
        className="w-[44px] h-[44px] md:w-[48px] md:h-[48px] rounded-full flex items-center justify-center text-white shadow-lg transition-all duration-300 hover:scale-110 active:scale-95"
        style={{ backgroundColor: "#2B2B2B" }}
        aria-label="Voltar ao topo"
      >
        <ArrowUp size={20} />
      </button>

      {/* WhatsApp */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="w-[52px] h-[52px] md:w-[56px] md:h-[56px] rounded-full flex items-center justify-center text-white shadow-lg transition-all duration-300 hover:scale-110 active:scale-95"
        style={{ backgroundColor: "#2B2B2B" }}
        aria-label="WhatsApp"
      >
        <MessageCircle size={24} />
      </a>
    </div>
  );
}
